/* eslint-disable no-underscore-dangle */
import Api from '../../helpers/api.js';
import apiMixin from '../../mixins/api.js';
import { entityApiRoutes } from '../../helpers/config.js';
import store from '@/store/index.js';
import { EventBus } from 'relapp-event';

/**
 * Create an API service.
 *
 * @param {string} model
 * @param {string} initRoutesEntity
 *
 * @return {object}
 */
const createApiService = (model, initRoutesEntity) => {
    let routesEntity = model;

    let latestCall;

    if (initRoutesEntity) {
        routesEntity = initRoutesEntity;
    }

    const routes = entityApiRoutes(routesEntity);

    const apiService = {
        /**
         * Call again the latest request.
         */
        reload() {
            if (latestCall) {
                this.get(latestCall.replace, latestCall.ignoreHandleError);
            }
        },
        /**
         * Call the get all endpoint.
         *
         * @param {array} replace
         * @param {boolean} ignoreHandleError
         *
         * @return {Promise}
         */
        get(replace, ignoreHandleError) {
            let route = routes['get'];

            if (replace) {
                replace.forEach(item => {
                    route = route.replace(item.key, item.value);
                });
            }

            latestCall = {
                replace,
                ignoreHandleError,
                route
            };

            return Api.get(route)
                .then(response => {
                    let storeData = null;

                    if (response.data.data) {
                        storeData = response.data.data;
                    }

                    if (Object.keys(store._actions).find(key => key === model + '/updateItems') && storeData) {
                        store.dispatch(model + '/updateItems', storeData);
                    }

                    return response;
                })
                .catch(err => {
                    if (ignoreHandleError) {
                        return Promise.reject(err);
                    }

                    return apiMixin.methods.handleError(err);
                });
        },

        /**
         * Add a new item endpoint.
         *
         * @param {array} data
         * @param {array} replace
         * @param {object} dataToStore
         *
         * @return {Promise}
         */
        add(data, replace, dataToStore) {
            let route = routes['post'];

            if (replace) {
                replace.forEach(item => {
                    route = route.replace(item.key, item.value);
                });
            }

            return Api.post(route, data)
                .then(response => {
                    let storeData = null;

                    if (response.data.data) {
                        storeData = response.data.data;
                    }

                    if (dataToStore) {
                        storeData = dataToStore;
                    }

                    if (Object.keys(store._actions).find(key => key === model + '/addItem') && storeData) {
                        store.dispatch(model + '/addItem', storeData);
                    }

                    return response;
                })
                .catch(error => {
                    return Promise.reject(error);
                });
        },

        /**
         * Update a item endpoint.
         *
         * @param {array} data
         * @param {array} replace
         * @param {object} dataToStore
         *
         * @return {Promise}
         */
        update(data, replace, dataToStore) {
            let route = routes['put'];

            if (replace) {
                replace.forEach(item => {
                    route = route.replace(item.key, item.value);
                });
            }

            return Api.put(route, data)
                .then(response => {
                    let storeData = response.data;

                    if (dataToStore) {
                        storeData = dataToStore;
                    }

                    if (Object.keys(store._actions).find(key => key === model + '/updateItem') && storeData) {
                        store.dispatch(model + '/updateItem', storeData);
                    }

                    return response;
                })
                .catch(error => {
                    return Promise.reject(error);
                });
        },

        /**
         * Delete a item endpoint.
         *
         * @param {object} item
         * @param {array} replace
         * @param {object} data
         *
         * @return {Promise}
         */
        delete(item, replace, data) {
            let route = routes['delete'];

            if (replace) {
                replace.forEach(replaceItem => {
                    route = route.replace(replaceItem.key, replaceItem.value);
                });
            } else {
                route = route.replace('{id}', item.id);
            }

            return Api.delete(route, data)
                .then(response => {
                    if (Object.keys(store._actions).find(key => key === model + '/removeItem')) {
                        store.dispatch(model + '/removeItem', item);
                    }

                    return response;
                })
                .catch(error => {
                    return Promise.reject(error);
                });
        },

        /**
         * Reset the store for the model.
         */
        reset() {
            if (Object.keys(store._actions).find(key => key === model + '/reset')) {
                store.dispatch(model + '/reset');
            }
        }
    };

    EventBus.$on('switchCustomer', () => {
        apiService.reload();
    });

    return apiService;
};

export { createApiService };
